import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.333 3.833V2.604c0-.794.644-1.437 1.438-1.437h8.125c.793 0 1.437.643 1.437 1.437v8.125c0 .794-.643 1.438-1.437 1.438h-1.23v1.229c0 .794-.643 1.437-1.437 1.437H3.104a1.438 1.438 0 0 1-1.438-1.437V5.27c0-.794.644-1.438 1.438-1.438h1.23Zm1-1.229c0-.241.196-.437.438-.437h8.125c.241 0 .437.196.437.437v8.125a.437.437 0 0 1-.437.438h-1.23V5.27c0-.794-.643-1.438-1.437-1.438H5.333V2.604ZM2.666 5.271c0-.242.196-.438.438-.438h8.125c.242 0 .438.196.438.438v8.125a.438.438 0 0 1-.438.437H3.104a.438.438 0 0 1-.438-.437V5.27Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }